import {
  AfterContentInit,
  Component,
  ContentChildren,
  ElementRef,
  QueryList,
  signal,
  ViewChild,
} from '@angular/core';
import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { AfraTabItemComponent } from '../tab-item.component/tab-item.component';

@Component({
  selector: 'afra-tab-panel',
  standalone: true,
  imports: [NgFor, NgIf, NgTemplateOutlet],
  styleUrl: './tab-panel.component.css',
  template: `
    <div class="tab-header" #tabHeader>
      <button
        *ngFor="let tab of items; let i = index"
        class="tab-btn"
        [class.active]="i === activeIndex()"
        (click)="select(i)"
      >
        {{ tab.title }}
      </button>
    </div>

    <div class="tab-body" *ngIf="activeItem">
      <ng-container *ngTemplateOutlet="activeItem.template"> </ng-container>
    </div>
  `,
})
export class AfraTabPanelComponent implements AfterContentInit {
  @ContentChildren(AfraTabItemComponent)
  items!: QueryList<AfraTabItemComponent>;

  @ViewChild('tabHeader', { static: true })
  tabHeader?: ElementRef<HTMLElement>;

  activeIndex = signal(0);

  activeItem?: AfraTabItemComponent;

  ngAfterContentInit() {
    this.setActive();

    this.items.changes.subscribe(() => {
      this.setActive();
    });
  }

  select(index: number) {
    this.activeIndex.set(index);
    this.setActive();
  }

  private setActive() {
    const list = this.items.toArray();
    this.activeItem = list[this.activeIndex()] ?? list[0];
  }
}
